const routes = [
  // 教育-编辑绘本
  {
    path: '/pictureBook/edit',
    name: 'pictureBook/edit',
    meta: {
      title: "编辑绘本",
      volcengine: true,
    },
    component: () => import('../pages/pictureBook/edit/index.vue'),
  },
]

export default routes